<template>
    <div :class="[ContentBlockBaseProps.Class, 'hero-swiper-nav-wrapper']" v-bind:style="ContentBlockBaseProps.Style">
        <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
            <div class="" v-bind:style="ContainerPadding">
                <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">

                    <swiper-container :slides-per-view="1"
                                      :loop="true"
                                      :simulate-touch="false"
                                      :navigation="SwiperNav"
                                      :pagination="false">

                        <swiper-slide v-for="slide in BlockProps.Slides" style="max-height:500px !important">

                            <img style="object-fit: cover; width: 100%; max-height: 500px !important; height:100%; object-position: center !important" class="" :src="slide.img" :alt="slide.imgAlt" />

                            <div class="slider-content-box" style="">
                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="slide.title" tag-name="h2" :init="EditorConfig" />
                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="slide.content" tag-name="div" :init="EditorConfig" />
                            </div>

                        </swiper-slide>

                    </swiper-container>
                    <div class="swiper-button-next" :class="'js-swiper-autoplay-button-next-' + this.BlockProps.UId"></div>
                    <div class="swiper-button-prev" :class="'js-swiper-autoplay-button-prev-' + this.BlockProps.UId"></div>

                </div>

                <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                    <div class="modal-dialog modal-dialog-scrollable">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Options - <button @click="Store.copyElementToArray(BlockProps.Slides, Store.DefaultBlockProps['HeroSwiper'].Slides, 0, 6)" type="button" class="btn btn-xs btn-info"><i class="bi bi-plus"></i> Add Slide</button> <small style="font-size:14px;color:darkgray">(current # of slides: {{BlockProps.Slides.length}} / 6 max)</small></h5>
                            </div>
                            <div class="modal-body">
                                <hr style="margin: 0px; margin-bottom:10px;" />
                                <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>

                                <small style="font-size:12px;"><i class="bi bi-exclamation-triangle"></i> Keep all background images dimensions for all slides the same for best appearance. </small>
                                <hr style="margin: 0px; margin-bottom:10px;" />
                                <div>
                                    <div class="row" v-for="(slide, slideIndex) in BlockProps.Slides">
                                        <div class="col col-11 text">
                                            <div style="display:inline-block; width: 100px !important;height: 75px !important;">
                                                <img style="object-fit:cover; width:100% !important; height:100% !important;object-position:center  !important;box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; border: 1px solid black" :src="slide.img" alt="Slide Background" />
                                            </div>

                                            <i class="bi bi-chevron-double-right"></i>
                                            <button @click="UploadNewSlideBackground(slideIndex)" type="button" style="margin-left:5px;" class="btn btn-sm btn-primary"><i class="bi bi-image"></i> Change Image</button>
                                            <button :disabled="BlockProps.Slides.length <= 1" @click="Store.deleteElementAtIndex(BlockProps.Slides, slideIndex)" type="button" style="margin-left:5px;" class="btn btn-sm btn-danger"><i class="bi bi-trash"></i> Delete Slide</button>
                                        </div>
                                        <div class="col col-1 d-flex align-items-center justify-content-center">
                                            <div id="target">
                                                <div class="row" style="padding:2px;">
                                                    <div v-if="slideIndex > 0" class="col col-12">
                                                        <button @click="Store.shiftElement(BlockProps.Slides, slideIndex, 'left')" data-toggle="tooltip" data-bs-toggle="tooltip" title="Move Up" type="button" style="width: 25px;" class="btn btn-xs btn-light"><i class="bi bi-chevron-up"></i></button>
                                                    </div>
                                                </div>
                                                <div class="row" style="padding:2px;">
                                                    <div v-if="slideIndex < (BlockProps.Slides.length - 1)" class="col col-12">
                                                        <button @click="Store.shiftElement(BlockProps.Slides, slideIndex, 'right')" data-toggle="tooltip" data-bs-toggle="tooltip" title="Move Down" type="button" style="width: 25px;" class="btn btn-xs btn-light"><i class="bi bi-chevron-down"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr style="margin-top: 5px; margin-bottom:5px;" />
                                    </div>
                                </div>

                                <!--<button @click="UploadNewAssetBlockConfig" type="button" class="btn btn-sm btn-secondary">Upload</button>-->
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                                <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'

    import { register } from 'swiper/element/bundle';
    register();

    // Swiper components


    export default {
        inheritAttrs: false,
        name: 'HeroSwiper',
        mixins: [ContentBlockBase],
        props: [],
        components: {

        },
        computed:
        {
            SwiperNav: function ()
            { 
                var config =
                    {
                        "nextEl" : '.js-swiper-autoplay-button-next-' + this.BlockProps.UId,
                        "prevEl" : '.js-swiper-autoplay-button-prev-' + this.BlockProps.UId,
                };
                return config;
            }
        },
        data() {
            return {  
            };
        },
        methods:
        {
            OnSlideBackgroundUploaded: function (args) {
                if(args.success){
                    if(args.idx >= this.BlockProps.Slides.length){
                        return;
                    }
                    if(args.url){
                        this.BlockProps.Slides[args.idx].img = args.url;                    
                    }
                }
                
                this.EditProperties();
            },
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            UploadNewSlideBackground: function(idx){
                this.HideEditProperties();
                var args = {};  
            
                args.ExistingFileURL = this.BlockProps.Slides[idx].img;
                args.CompleteCallback = "OnSlideBackgroundUploaded-" + this.BlockProps.UId;
                args.CompleteCallbackData = {idx: idx, url: ''}; // this will be sent back in the callback
                args.Prompt = `Background image for slide ${idx + 1}`;
                EventHub.$emit('UploadNewAssetBlockConfig', args);
            }
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            EventHub.$on('OnSlideBackgroundUploaded-' + this.BlockProps.UId, this.OnSlideBackgroundUploaded);      
        },
        beforeUnmount()
        {
            EventHub.$off('OnSlideBackgroundUploaded-' + this.BlockProps.UId, this.OnSlideBackgroundUploaded);      
        },
        mounted() {
            nextTick().then(() => {
            //(function () {
            //    // INITIALIZATION OF SWIPER
            //    // =======================================================
            //    var swiper = new Swiper('.js-swiper-autoplay-' + that.BlockProps.UId, {
            //        //spaceBetween: 30,
            //        effect: 'slide',
            //        //zoom: true,
            //        // centeredSlides: true,
            //        // autoHeight: false, //enable auto height
            //        loop: true,
            //        //cssMode: true, 
            //        //autoplay: {
            //        //    delay: 7000,
            //        //    disableOnInteraction: true,
            //        //},
            //        simulateTouch:false,
            //        autoplay: false,
            //        //observer: true,
            //        //observeSlideChildren: true,
            //        //observeParents: true,
            //        //virtual:true,
            //        //lazyPreloadPrevNext: 10,
            //        pagination: {
            //            el: '.js-swiper-autoplay-pagination',
            //            clickable: true,
            //        },
            //        navigation: {
            //            nextEl: '.js-swiper-autoplay-button-next-' + that.BlockProps.UId,
            //            prevEl: '.js-swiper-autoplay-button-prev-' + that.BlockProps.UId,
            //        },
            //    });
            //    //slideChangeTransitionEnd
            //    swiper.on('slideChange', function () {
            //      console.log('slide changed');
            //    });
            //    })(); 
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .hero-swiper-nav-wrapper {
        position: relative;
    }

    .hero-swiper-nav-wrapper .swiper-button-next,
    .hero-swiper-nav-wrapper .swiper-button-prev {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 5;
    }

    .hero-swiper-nav-wrapper .swiper-button-next {
        right: 10px;
    }

    .hero-swiper-nav-wrapper .swiper-button-prev {
        left: 10px;
    }

    .ce-block .ce-block--focused {
        border: 1px dashed #cbcbcb !important
    }
    #editorjs {
        color: green;
    }

    .slider-content-box-action {
        float: right !important;
        margin-bottom: 10px !important;
        margin-right: 10px !important;
    }

    .mce-content-body [data-mce-selected=inline-boundary] {
        background-color: unset !important;
    }
</style>

